import {assetsForCss} from '../../../tools/Tools';

export default theme => ({
  loginContainer: {
    background: 'url(' + assetsForCss('/img/default-background.jpg') + ')',
    backgroundSize: 'cover',
    height: '100vh',
    width: '100%'
  },
  paper: {
    padding: '2em'
  },
  title: {
    textAlign: 'center',
    marginTop: theme.spacing.unit * 2
  },
  avatar: {
    backgroundColor: 'white',
    borderRadius: '5px',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '5em',
    width: '5em'
  },
  textField: {
    width: '100%'
  },
  buttonsLign: {
    marginTop: '3em'
  },
  button: {
    width: '100%',
    marginBottom: theme.spacing.unit
  }
})
